import { render, staticRenderFns } from "./CollaboratorDetail.vue?vue&type=template&id=4a179eca&scoped=true&"
import script from "./CollaboratorDetail.vue?vue&type=script&lang=js&"
export * from "./CollaboratorDetail.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorDetail.vue?vue&type=style&index=0&id=4a179eca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a179eca",
  null
  
)

export default component.exports